import Analytics from "../Analytics";
import get from "lodash/get";
import forEach from "lodash/forEach";
import isArray from "lodash/isArray";
import { COUNTRY } from "utils/constants";
import { GA4_WHITELISTED_TRIGGERS } from "../../constants/AnalyticsTypeConstants";
import TagManager from "react-gtm-module";
import { constructEcommerceEventData } from "analytics/utils/googleTagManager4Analytics/googleAnalyticsHelpers";

const submitEventDataToGA = (
  eventData = "",
  tagManager,
  googleTagManagerID = ""
) => {
  let tagManagerArgs = {
    dataLayer: eventData
  };
  // tagManager.initialize({
  //   gtmId: googleTagManagerID,
  //   dataLayer: { ecommerce: null }
  // });
  tagManager.dataLayer(tagManagerArgs);
  window.dataLayer.push({ ecommerce: null });
};

class GoogleTagManager4Analytics extends Analytics {
  pushEvent(event, data, message, reduxStore) {
    /**
     * Push events to Google Tag Manager
     * @param {string} event type of event triggered based on user actions, page load and etc.
     * @param {object} data data associated with triggered event
     */
    this.pushToDataLayer(event, data, message, reduxStore);
  }

  pushToDataLayer(
    triggerKey,
    data,
    message,
    reduxStore,
    country = COUNTRY?.toLowerCase(),
    googleTagManagerID = get(window, "GOOGLE_TAG_MANAGER_ID", ""),
    tagManager = TagManager
  ) {
    const datalayerEvent = () => {
      if (GA4_WHITELISTED_TRIGGERS[triggerKey]) {
        const ecommerceDataLayerEventData = constructEcommerceEventData(
          triggerKey,
          data,
          reduxStore
        ); // can be array or object, depending on whether multiple events need to be fired on one trigger
        if (
          isArray(ecommerceDataLayerEventData) &&
          get(window, "GOOGLE_TAG_MANAGER_ID", "")
        ) {
          // Scenarios where trigger has more than one event data to push to GA
          forEach(ecommerceDataLayerEventData, eventData => {
            if (get(eventData, "event")) {
              submitEventDataToGA(
                eventData,
                tagManager,
                get(window, "GOOGLE_TAG_MANAGER_ID", "")
              );
            }
          });
        } else {
          // Scenarios where trigger only has one event data to push to GA
          if (get(ecommerceDataLayerEventData, "event")) {
            submitEventDataToGA(
              ecommerceDataLayerEventData,
              tagManager,
              get(window, "GOOGLE_TAG_MANAGER_ID", "")
            );
          }
        }
      }
    };

    if (!get(window, "GOOGLE_TAG_MANAGER_ID")) {
      setTimeout(() => {
        datalayerEvent();
      }, 1000);
    } else {
      datalayerEvent();
    }
  }
}
export default new GoogleTagManager4Analytics();
